import 'chart.js/auto'

import {
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js'
import { memo } from 'react'
import { Line } from 'react-chartjs-2'

import styles from '../assets/css/components/LineChart.module.css'
import DataNotFound from './DataNotFound'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

interface LineChartProps {
  labels: string[]
  datas: number[]
  groupLabel: string
  xAxisLabel: string
  yAxisLabel: string
}

const LineChart = memo(({ labels, datas, groupLabel, xAxisLabel, yAxisLabel }: LineChartProps) => {
  // if there is all 0 in datas, return null
  if (datas.every((d) => d === 0)) {
    return <DataNotFound className='min-h-[33vh]' />
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function ticks1stDayOfTheMonth(index: any) {
    if (datas.length < 180) return labels[index]
    return labels[index].slice(-2) === '01' ? labels[index] : null
  }

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        displayColors: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: '',
      },
    },
    scales: {
      x: {
        offset: true,
        ticks: {
          callback: ticks1stDayOfTheMonth,
        },
        title: {
          display: true,
          text: xAxisLabel,
        }
      },
      y: {
        title: {
          display: false,
        },
        ticks: {
          callback(value: number | string) {
            return value;
          }
        }
      }
    },
    layout: {
      padding: {
        top: 30 // グラフ上部にスペースを追加
      }
    }
  }

  const data = {
    labels,
    datasets: [
      {
        label: groupLabel,
        data: datas.map((d) => d.toString()),
        borderWidth: 2,
        borderColor: '#00CC00',
        backgroundColor: '#00CC00',
        pointRadius: 1,
        pointHitRadius: 20,
      },
    ],
  }
  return (
    <div className="relative min-h-[33vh]">
      <div className={`absolute top-0 left-0 w-full text-xs font-normal ${styles.customLabel}`}>
        {yAxisLabel}
      </div>
      <Line options={options} data={data} />
    </div>
  )
})

export default LineChart